<q9-loading-placeholder [isLoading]="showLoader"></q9-loading-placeholder>
<router-outlet></router-outlet>
